export default __webpack_public_path__ + "images/d2ca4341f5de7b939a6c016028fbf719-fogape.svg";